import { Subject } from 'rxjs';

import { catchError } from 'rxjs/operators';

import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders} from '@angular/common/http';

@Injectable()
export class AppConfig {

    private config!: any;
    private env!:    any;

    public supportiveDocsVisible:boolean=false;
    public supportiveDocURLArray = new Array<string>();

    public tokenReceivedSubject = new Subject();

    public optionsText = { headers: new HttpHeaders().set('Content-Type', 'application/text') };
    public optionsJson = { headers: new HttpHeaders().set('Content-Type', 'application/json') };
    public optionsForm = { headers: new HttpHeaders().set('Content-Disposition', 'multipart/form-data') };

    constructor(private httpClient: HttpClient) {

    }

    /**
     * Use to get the data found in the second file (config file)
     */
    public getConfig(key: any) {
        return this.config[key];
    }

    /**
     * Use to get the data found in the first file (env file)
     */
    public getEnv(key: any) {
        return this.env[key];
    }

    public getConfigAll(){
        return this.config;
    }

    public initHeaders(){
        this.optionsJson.headers = this.optionsJson.headers.set('Authorization','Bearer ' + this.accessToken); //careful: headers.set returns a clone!
        this.optionsForm.headers = this.optionsForm.headers.set('Authorization','Bearer ' + this.accessToken); //careful: headers.set returns a clone!
    }

    private get tokenKey(): string {
        const env = this.getEnv('env') ?? 'unknown';
        return `refreshToken_${env}`;
    }

    get accessToken(){
        return sessionStorage.getItem('accessToken') ?? '';
    }
    set accessToken(token:string){
        sessionStorage.setItem('accessToken', token);
        this.optionsJson.headers = this.optionsJson.headers.set('Authorization','Bearer ' + token); //careful: headers.set returns a clone!
        this.optionsForm.headers = this.optionsForm.headers.set('Authorization','Bearer ' + token); //careful: headers.set returns a clone!
        this.tokenReceivedSubject.next(undefined);
    }
   
    get refreshToken(): string | null {
        return localStorage.getItem(this.tokenKey);
    }

    set refreshToken(token: string) {
        localStorage.setItem(this.tokenKey, token);
    }

    get authHeader(){
        return 'Bearer ' + this.accessToken;
    }

    get isDev():boolean{
        return this.env['env'] == 'development';
    }

    get isStage():boolean{
        return this.env['env'] == 'staging';
    }

    get isProd():boolean{
        return this.env['env'] == 'production';
    }

    public clearTokens(){
        sessionStorage.removeItem('accessToken');
        //don't clear out refreshToken; user might have another session open
    }

    /**
     * This method:
     *   a) Loads "env.json" to get the current working environment (e.g.: 'production', 'development')
     *   b) Loads "config.[env].json" to get all env's variables (e.g.: 'config.development.json')
     */
    public load() {
        return new Promise((resolve, _reject) => {
            this.httpClient.get('env.json').pipe(catchError((error: any):any => {
                console.log('Configuration file "env.json" could not be read');
                resolve(true);
                return new Error (error.error || 'Server error');
            }),).subscribe( (envResponse:any) => {
                this.env = envResponse;
                switch (envResponse.env) {
                    case 'production':
                    case 'staging':
                    case 'development': {
                            this.httpClient.get('config.' + envResponse.env + '.json').pipe(catchError((error: any):any => {
                                    console.error('Error reading ' + envResponse.env + ' configuration file');
                                    resolve(error);
                                    return new Error(error.error || 'Server error');
                                }),).subscribe((responseData:any) => {
                                    this.config = responseData;
                                    resolve(true);
                                });
                        } 
                        break;

                    case 'default': {
                            console.error('Environment file is not set or invalid');
                            resolve(true);
                        } 
                        break;
                }

               
            });
        });
    }
}